import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initDB } from './utils/offlineDb';
import { initSyncManager } from './utils/syncManager';

// Initialize IndexedDB
initDB().then(() => {
  console.log('IndexedDB initialized');
  // Initialize sync manager
  initSyncManager();
}).catch(error => {
  console.error('Failed to initialize IndexedDB:', error);
});

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful');
        
        // Check for updates immediately and every hour
        registration.update();
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      },
      (err) => {
        console.log('ServiceWorker registration failed: ', err);
      }
    );
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);